import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

interface CTAButtonProps {
  ariaLabel: string;
  containerClass?: string;
  buttonClass?: string;
  text: string;
  icon: IconProp;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
}

export default function CTAButton({
  ariaLabel,
  containerClass,
  buttonClass,
  text,
  icon,
  disabled = false,
  loading = false,
  onClick,
}: CTAButtonProps) {
  return (
    <div className={classNames('flex', containerClass)}>
      <button
        aria-label={ariaLabel}
        className={classNames(
          'inline-block flex justify-center items-center',
          'w-full py-3 px-6 rounded-full shadow-md cursor-pointer',
          'font-avenir-medium text-sm md:text-base',
          'bg-primary-blue text-white',
          'transition duration-150 ease-in-out',
          buttonClass,
          { 'hover:bg-navy-blue': !disabled && !loading },
          { 'bg-opacity-60 shadow-none': disabled },
          { '!bg-navy-blue': loading },
          { 'cursor-default': disabled }
        )}
        type="submit"
        onClick={onClick}
        disabled={disabled}
      >
        <div className="flex justify-center items-center">
          <span className="hidden xs:inline w-6">
            {icon && !loading && (
              <FontAwesomeIcon icon={icon} className="mr-2" />
            )}
            {loading && (
              <FontAwesomeIcon
                icon={['far', 'spinner-third']}
                className="mr-2"
                spin
              />
            )}
          </span>
          <span>{text}</span>
        </div>
      </button>
    </div>
  );
}
